import { render, staticRenderFns } from "./SubEmpresaBlocoInformacao.vue?vue&type=template&id=1b08692a&lang=pug"
import script from "./SubEmpresaBlocoInformacao.vue?vue&type=script&lang=js"
export * from "./SubEmpresaBlocoInformacao.vue?vue&type=script&lang=js"
import style0 from "./SubEmpresaBlocoInformacao.vue?vue&type=style&index=0&id=1b08692a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports